/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import { AlertCircle, Clock } from 'lucide-react';

/** Copy + visual meta for each onboarding next-step, keyed by backend `next_step`. */
export const NEXT_STEP_META = {
  tier1: {
    label: 'Completa profilo',
    detail: 'Verifica identità',
    detailLong: 'Bastano 2 minuti — nome, cognome, CF, telefono e conferma email',
    Icon: AlertCircle,
    tone: 'primary',
    percent: 15,
    incentive: null,
  },
  tier2: {
    label: 'Verifica Albo',
    detail: 'Carica Albo / OPI / OSS',
    detailLong: 'Screenshot dal sito FNOMCeO / IPASVI: verifica manuale entro 24h',
    Icon: AlertCircle,
    tone: 'primary',
    percent: 45,
    incentive: null,
  },
  tier2_awaiting_review: {
    label: 'In revisione',
    detail: 'Il team ti verifica',
    detailLong: 'Il nostro team sta controllando la tua iscrizione all\'Albo (max 24–48h).',
    Icon: Clock,
    tone: 'muted',
    percent: 66,
    incentive: null,
  },
  tier3: {
    label: 'Attiva pagamenti',
    detail: 'Studio + P.IVA',
    detailLong: 'Indirizzo studio, P.IVA e prezzo visita — 3 minuti e sei live',
    Icon: AlertCircle,
    tone: 'accent',
    percent: 80,
    incentive: '🎁 Prima visita senza commissione',
  },
};

export const TONE_STYLES = {
  primary: 'bg-primary/10 text-primary hover:bg-primary/15 border-primary/25',
  accent: 'bg-amber-500/10 text-amber-700 dark:text-amber-300 hover:bg-amber-500/15 border-amber-500/25',
  muted: 'bg-secondary/70 text-muted-foreground hover:bg-secondary border-border',
};

export const metaForStep = (nextStep) => NEXT_STEP_META[nextStep] || NEXT_STEP_META.tier1;
